import { Component, OnInit, ElementRef, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ApplicationPool } from "src/app/services/application.pool";
import { Reader } from "src/app/models/reader";
import { styles } from "../printing-styles";
import { Library } from "src/app/models/library";
import { EmptyPageService } from "src/app/services/empty-page.service";
import { ActionService } from "src/app/services/action.service";

@Component({
  selector: "app-print-reader-barcodes",
  templateUrl: "./print-reader-barcodes.component.html",
  styles,
})
export class PrintReaderBarcodesComponent implements OnInit {
  @ViewChild("content") contentRef: ElementRef;

  private ids: number[] = [];
  private print: boolean = true;
  private href: string = null;

  public blankBarcodes: number[] = [];

  public get Library(): Library {
    return this.dataPool.Library;
  }

  public get Width(): string {
    if (this.Library) {
      return `${this.Library.configuration.barcodeDimensions.width}cm`;
    }
  }
  public get Height(): string {
    if (this.Library) {
      return `${this.Library.configuration.barcodeDimensions.height}cm`;
    }
  }
  public get MarginLeft(): string {
    if (this.Library) {
      return `${this.Library.configuration.barcodeDimensions.sheetMarginLeft}cm`;
    }
  }
  public get MarginTop(): string {
    if (this.Library) {
      return `${this.Library.configuration.barcodeDimensions.sheetMarginTop}cm`;
    }
  }

  public get Readers(): Reader[] {
    if (this.dataPool.Readers) {
      const readers = this.dataPool.Readers.filter(
        (m) => this.ids.filter((id) => m.id == id).length > 0
      );
      if (this.print) {
        this.print = false;
        const t = this;
        setTimeout(() => {
          this.emptyPageService.render(
            `<html moznomarginboxes mozdisallowselectionprint><head><style>${styles[0]} @page { margin-top: ${t.MarginTop}; margin-left: ${t.MarginLeft}; margin-right: 0px; margin-bottom:0px;} reader-barcode {width: ${t.Width}; height: ${t.Height};}
            div.signature {
             text-align: center;
             display: table!important;
             height:100%;
             font-size: 25px !important;
             line-height: 30px; 
             float:left;
             
           }
           div.signature>div {
             display:table-cell;
             vertical-align:middle;
           }
           div.signature * {
             font-size: 17px !important;
             line-height: 25px;
           }
           div.signature .id {font-size:90%}
           body {margin:0px;}
            
           </style></head><body>${this.contentRef.nativeElement.innerHTML}</body></html>`
          );
          setTimeout(() => {
            this.emptyPageService.print();
          }, 100);

          if (this.href) {
            this.router.navigate([this.href.replace(/\%2F/gi, "/")]);
          } else {
            this.router.navigate(["/reader/barcode"]);
          }
        }, 50);
      }
      return readers;
    }
  }

  constructor(
    private route: ActivatedRoute,
    private dataPool: ApplicationPool,
    private router: Router,
    private emptyPageService: EmptyPageService,
    private dataService: ActionService
  ) {
    this.route.params.subscribe((params: any[]) => {
      const val = JSON.parse(params["val"]);
      this.ids = JSON.parse(val.reader);
      this.href = val.href;
      const blank: any = val.blankBarcodes;
      if (blank) {
        let blankBarcodesCount = +blank;
        while (blankBarcodesCount-- > 0) {
          this.blankBarcodes.push(0);
        }
      }
    });
  }

  ngOnInit(): void {}
}
